function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.79995 16.8V16.8C2.79995 19.1196 4.68035 21 6.99995 21L20.9999 21C23.3195 21 25.2 19.1196 25.2 16.8V16.8",
  stroke: "white",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.8 12.6001L1.80553 14.3404C1.00101 15.7483 2.01761 17.5001 3.63916 17.5001V17.5001C4.00668 17.5001 4.36785 17.4042 4.68695 17.2218L5.425 16.8001C6.18407 16.3663 7.11593 16.3663 7.875 16.8001V16.8001C8.63407 17.2339 9.56593 17.2339 10.325 16.8001V16.8001C11.0841 16.3663 12.0159 16.3663 12.775 16.8001V16.8001C13.5341 17.2339 14.4659 17.2339 15.225 16.8001V16.8001C15.9841 16.3663 16.9159 16.3663 17.675 16.8001V16.8001C18.4341 17.2339 19.3659 17.2339 20.125 16.8001V16.8001C20.8841 16.3663 21.8159 16.3663 22.575 16.8001L23.3131 17.2218C23.6322 17.4042 23.9933 17.5001 24.3608 17.5001V17.5001C25.9824 17.5001 26.999 15.7483 26.1945 14.3404L25.2 12.6001",
  stroke: "white",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.0999 12.6001L20.1785 14.5477C19.3757 15.0829 18.3645 15.1993 17.461 14.8605L14.5248 13.7594C13.7437 13.4665 12.8759 13.5121 12.1298 13.8851L10.6571 14.6215C9.69416 15.103 8.54709 15.0316 7.65133 14.4344L4.8999 12.6001",
  stroke: "white",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 14.3,
  y1: 5.6001,
  x2: 14.3,
  y2: 9.8001,
  stroke: "white",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 19.8999,
  y1: 5.6001,
  x2: 19.8999,
  y2: 9.8001,
  stroke: "white",
  strokeWidth: 2
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 8.69995,
  y1: 5.6001,
  x2: 8.69995,
  y2: 9.8001,
  stroke: "white",
  strokeWidth: 2
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M25.2 12.6001V11.6001C25.2 8.28639 22.5138 5.6001 19.2001 5.6001H8.80005C5.48634 5.6001 2.80005 8.28639 2.80005 11.6001V12.6001",
  stroke: "white",
  strokeWidth: 2
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M2.80005 12.6001H25.2",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "square"
});

var SvgSandwich = function SvgSandwich(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSandwich, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sandwich.2829e45b.svg";
export { ForwardRef as ReactComponent };